import React, { useEffect, useState } from "react";
import FirstButton from "../common/button";
import { TextField, Card } from "@mui/material";
import BreadCrumbs from "./BreadCrumbs";
import api from "../Axios";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment/moment";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import DisabledByDefaultIcon from "@mui/icons-material/DisabledByDefault";
import PushPinIcon from "@mui/icons-material/PushPin";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import algeo from "../assets/images/dealcontours/Available geographies.png";
import Supplystatus from "../assets/images/dealcontours/Supply status.png";
import Techtransfersupport from "../assets/images/dealcontours/Tech transfer.png";
import Dealtype from "../assets/images/dealcontours/Deal type.png";
import Exclusivity from "../assets/images/dealcontours/exclusivity.png";
import MAholder from "../assets/images/dealcontours/envelope-mail-email-send-svgrepo-com (2).png";
import IPowner from "../assets/images/dealcontours/IP owner.png";
import Details from "../assets/images/dealcontours/Details.png";
import Onetimefee from "../assets/images/dealcontours/One-time fee.png";
import Royalty from "../assets/images/dealcontours/royalty.png";
import Profitshare from "../assets/images/dealcontours/Profit share.png";
import RDdetails from "../assets/images/Manufacturing Details/R&D details.png";
import Submissionbatchmfg from "../assets/images/Manufacturing Details/Submission batch.png";
import GMPstatus from "../assets/images/Manufacturing Details/GMP.png";
import LastInspection from "../assets/images/Manufacturing Details/Last inspection.png";
import Countryofmanufacture from "../assets/images/Manufacturing Details/Country of manufacture.png";
import APIsources from "../assets/images/Manufacturing Details/API sources.png";
import APItype from "../assets/images/Manufacturing Details/API type.png";
import APIDMF from "../assets/images/Manufacturing Details/API DMF.png";
import CPPcountry from "../assets/images/Manufacturing Details/Batch - Copy.png";
import Batchsize from "../assets/images/Manufacturing Details/Batch.png";
import StabilityCondition from "../assets/images/Manufacturing Details/Stability.png";
import MOQ from "../assets/images/Manufacturing Details/MOQ.png";
import CRO from "../assets/images/Manufacturing Details/CRO.png";
import DoseForm from "../assets/images/ProductProfile/Dose form.png";
import RouteofAdministration from "../assets/images/ProductProfile/Route of admin.png";
import Strengths from "../assets/images/ProductProfile/Strength.png";
import Salt from "../assets/images/ProductProfile/Salt form.png";
import Therapeutic from "../assets/images/ProductProfile/Therapeutic Category.png";
import CategoryDetails from "../assets/images/ProductProfile/Category details.png";
import Indication from "../assets/images/ProductProfile/Indication.png";
import USRef from "../assets/images/ProductProfile/US ref product.png";
import USConstraint from "../assets/images/ProductProfile/US Constraint date.png";
import PrescriptionStatus from "../assets/images/ProductProfile/Prescription status.png";
import Packstyle from "../assets/images/ProductProfile/Pack style.png";
import Packsizes from "../assets/images/ProductProfile/Pack sizes.png";
import CTBE from "../assets/images/ProductProfile/CT BE CRO.png";
import Dossierstatus from "../assets/images/ProductProfile/Dossier status.png";
import Registeredin from "../assets/images/ProductProfile/Registered in (2).png";
import Tooltip from "@mui/material/Tooltip";
import noData from "../assets/images/noData.png";
const ProductDetails = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [productdetails, setProductdetails] = useState([]);
  const [dealCounter, setDealCounter] = useState([]);
  const [manufDetails, setManufDetails] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [supportServices, setSupportServices] = useState([]);
  let grayTableRowPredicate = (val) => {
    return ["-", "na", "not applicable", "non-mdantory"].includes(
      val?.toLowerCase(),
    );
  };
  let { id } = useParams();
  const urls = [
    { name: "Home", url: "/home" },
    { name: "Dossier Search", url: "/dossier-search" },
    { name: "Product Details", url: "" },
  ];

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page
    getProductDetails();
  }, []);
  const getProductDetails = () => {
    const data = { id: id };
    api
      .post("get-dossierbyid", data)
      .then((resp) => {
        setData(resp?.data?.data);

        const tempSupplierData = [
          {
            name: resp?.data?.data?.SupplierHQLocation,
            checked: true,
            img: <PushPinIcon style={{ fontSize: "28px", color: "#6a1ca5" }} />,
          },

          {
            name: "R&D Capabilities",
            checked: resp?.data?.data?.RDCapabilities === "Yes",
          },
          {
            name: "Manufacturing",

            checked: resp?.data?.data?.Manufacturing === "Yes",
          },
          {
            name: "Front End Markets",

            checked: resp?.data?.data?.FrontEndMarkets === "Yes",
          },

          {
            name: "API",

            checked: resp?.data?.data?.SupplierAPIFlag === "Yes",
          },
        ];

        const tempSupportServices = [
          {
            name: `Estd ${resp?.data?.data?.YearsInOperation}`,
            checked: true,
            img: (
              <FlagCircleIcon style={{ fontSize: "28px", color: "#6a1ca5" }} />
            ),
          },
          {
            name: "Regulatory support",
            checked: resp?.data?.data?.RegulatorySupport === "Yes",
          },
          {
            name: "Incremental R&D",
            checked: resp?.data?.data?.IncrementalRD === "Yes",
          },
          {
            name: "Tech-transfer",
            checked: resp?.data?.data?.TechTransferSupport === "Yes",
          },
          {
            name: "Stability loading",
            checked: resp?.data?.data?.StabilityLoading === "Yes",
          },
        ];

        setSupplierData(tempSupplierData);
        setSupportServices(tempSupportServices);
        setProductdetails(
          convertProductDetails(resp?.data?.data?.productDetails),
        );
        setDealCounter(convertDealCounter(resp?.data?.data?.dealContours));
        setManufDetails(
          convertmanufDetails(resp?.data?.data?.manufacturingDetails),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const convertProductDetails = (productDetails) => {
    return [
      {
        label: "Dose Form",
        value: productDetails?.doseForm,
        image: DoseForm,
      },
      {
        label: "Route of Administration",
        value: (productDetails?.routeOfAdministration ?? []).join(", "),
        image: RouteofAdministration,
      },
      {
        label: "Strengths",
        value: productDetails?.strengths,
        image: Strengths,
      },
      {
        label: "Salt",
        value: productDetails?.saltBase,
        image: Salt,
      },
      {
        label: "Therapeutic Category",
        value: (productDetails?.therapCategory ?? []).join(", "),
        image: Therapeutic,
      },
      {
        label: "Category Details",
        value: (productDetails?.atcClass ?? []).join(", "),
        image: CategoryDetails,
      },
      {
        label: "Indication",
        value: productDetails?.indication,
        image: Indication,
      },
      {
        label: "US Ref product*",
        value: productDetails?.usRefProduct,
        image: USRef,
      },
      {
        label: "US Constraint date",
        value:
          productDetails?.usConstraintDate === "01-Jan-1900"||productDetails?.usConstraintDate === null||productDetails?.usConstraintDate === undefined
            ? "-"
            : moment(productDetails?.usConstraintDate).format("DD-MMM-YYYY"),
        image: USConstraint,
      },
      {
        label: "Prescription Status",
        value: productDetails?.rxOtc,
        image: PrescriptionStatus,
      },
      {
        label: "Pack style 1",
        value: productDetails?.packStyle1,
        image: Packstyle,
      },
      {
        label: "Pack sizes",
        value: (productDetails?.packSizes1 ?? []).join(", "),
        image: Packsizes,
      },
      {
        label: "Pack style 2",
        value: productDetails?.packStyle2,
        image: Packstyle,
      },
      {
        label: "Pack sizes",
        value: (productDetails?.packSizes2 ?? []).join(", "),
        image: Packsizes,
      },
      {
        label: "CT/ BE details",
        value: productDetails?.ctBeDetails,
        image: CTBE,
      },
      {
        label: "Dossier status",
        value: productDetails?.dossierStatus,
        image: Dossierstatus,
      },
      {
        label: "Registered in",
        value: productDetails?.registeredIn,
        image: Registeredin,
      },
    ];
  };

  const convertDealCounter = (dealCounter) => {
    return [
      {
        label: "Available geographies",
        value: (dealCounter?.availableGeographies ?? []).join(", "),
        image: algeo,
      },
      {
        label: "Supply status",
        value: (dealCounter?.supplyInternalStatus ?? []).join(", "),
        image: Supplystatus,
      },
      {
        label: "Tech transfer support",
        value: dealCounter?.techTransferSupport,
        image: Techtransfersupport,
      },
      {
        label: "Deal type",
        value: dealCounter?.dealType,
        image: Dealtype,
      },
      {
        label: "Exclusivity",
        value: dealCounter?.exclusivity,
        image: Exclusivity,
      },
      { label: "MA holder", value: dealCounter?.maHolder, image: MAholder },
      { label: "IP owner", value: dealCounter?.ipOwner, image: IPowner },
      {
        label: "Details",
        value: dealCounter?.details,
        image: Details,
      },
      {
        label: "One time fee",
        value: dealCounter?.oneTimeFee,
        image: Onetimefee,
      },
      { label: "Royalty", value: dealCounter?.royalty, image: Royalty },
      {
        label: "Profit share",
        value: dealCounter?.profitShare,
        image: Profitshare,
      },
    ];
  };
  const convertmanufDetails = (manufacturingDetails) => {
    return [
      {
        label: "R&D details",
        value: manufacturingDetails?.rAndDDetails,
        image: RDdetails,
      },
      {
        label: "Submission batch mfg",
        value: manufacturingDetails.submissionBatchMfg,
        image: Submissionbatchmfg,
      },
      {
        label: "GMP status",
        value: (manufacturingDetails?.gmpStatus ?? []).join(", "),
        image: GMPstatus,
      },
      {
        label: "Last Inspection",
        value: manufacturingDetails?.lastInspection,
        image: LastInspection,
      },
      {
        label: "Country of manufacture",
        value: (manufacturingDetails?.CountryOfManufactureInternal ?? [])
          .map((item) => `${item}`)
          .join(", "),
        image: Countryofmanufacture,
      },
      {
        label: "# of API sources",
        value: manufacturingDetails?.numberOfApiSources,
        image: APIsources,
      },
      {
        label: "API type",
        value: manufacturingDetails?.apiType,
        image: APItype,
      },
      {
        label: "API DMF",
        value: manufacturingDetails?.apiDmf,
        image: APIDMF,
      },
      {
        label: "CPP country",
        value: manufacturingDetails?.cppCountry,
        image: CPPcountry,
      },
      {
        label: "Batch size",
        value: manufacturingDetails?.batchSize,
        image: Batchsize,
      },
      { label: "MOQ", value: manufacturingDetails?.moq, image: MOQ },
      { label: "CRO", value: manufacturingDetails?.cro, image: CRO },
      {
        label: "Stability Condition",
        value: manufacturingDetails?.StabilityCondition,
        image: StabilityCondition,
      },
    ];
  };

  return (
    <div className="p14 backgroundColor">
      <BreadCrumbs array={urls} />

      {data?.ListingCode ? (
        <>
          <div className="p-4 bg-white mt-4">
            <div className="ps_main mb-4">
              <h1 className="fw-600"> Product Code-{data?.ListingCode}</h1>
              <h3 className="fw-600">Product Details</h3>
              <FirstButton
                className="borderbtn"
                buttonText="Back to Search Results"
                width="30%"
                onClick={() => navigate("/dossier-search")}
              />
            </div>
            <div className="ps_main">
              <h3 className="fw-600">
                {[
                  data?.ListingTitle,
                  productdetails[0]?.value,
                  // productdetails[3]?.value,
                ]
                  .filter(Boolean)
                  .join(" ")}
              </h3>

              <FirstButton
                className="btn"
                buttonText="Request Term Sheet"
                width="30%"
                onClick={() => navigate(`/product-term-sheet/${id}`)}
              />
            </div>
          </div>
          <div>
            <hr />
            <div className="dfcg3">
              <div className="flex1 ">
                <h2 className="my-2  heading-bg-color text-white">
                  Product Profile
                </h2>
                {/* <table class="table  bx-shadow">
                  <tbody>
                    {productdetails &&
                      productdetails.map((item, index) => (
                        <tr key={index}>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14 fw-600"
                                : "p-3 fs-14  fw-600"
                            }
                            style={{ width: "45%" }}
                          >
                            <span
                              className="me-4"
                              style={{ color: "#a947d3", fontSize: "24px" }}
                            >
                              <img
                                src={item?.image}
                                style={{ width: "28px" }}
                                alt="icon"
                              />
                            </span>

                            {item.label}
                          </td>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14"
                                : "p-3 fs-14  "
                            }
                            style={{ width: "65%" }}
                          >
                            {item.label === "US Constraint date" ? (
                              <Tooltip
                                title={
                                  <span style={{ fontSize: "14px" }}>
                                    This date reflects the estimated end of
                                    FDA-granted exclusivities. However,
                                    additional patents or legal constraints may
                                    still apply. Buyers are advised to conduct
                                    their own due diligence before assuming
                                    generic launch readiness.
                                  </span>
                                }
                                arrow
                              >
                                <span className="fs-14">{item.value}</span>
                              </Tooltip>
                            ) : (
                              item.value
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table> */}
                <table className="table bx-shadow">
                  <tbody>
                    {productdetails
                      ?.filter((item) => {
                        const value = item?.value;

                        // hide empty values
                        if (value === null || value === undefined) return false;
                        if (Array.isArray(value) && value.length === 0)
                          return false;
                        if (typeof value === "string" && value.trim() === "")
                          return false;

                        return true;
                      })
                      .map((item, index) => (
                        <tr key={index}>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14 fw-600"
                                : "p-3 fs-14 fw-600"
                            }
                            style={{ width: "45%" }}
                          >
                            <span
                              className="me-4"
                              style={{ color: "#a947d3", fontSize: "24px" }}
                            >
                              <img
                                src={item?.image}
                                style={{ width: "28px" }}
                                alt="icon"
                              />
                            </span>
                            {item.label}
                          </td>

                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14"
                                : "p-3 fs-14"
                            }
                            style={{ width: "65%" }}
                          >
                            {item.label === "US Constraint date" ? (
                              <Tooltip
                                title={
                                  <span style={{ fontSize: "14px" }}>
                                    This date reflects the estimated end of
                                    FDA-granted exclusivities. However,
                                    additional patents or legal constraints may
                                    still apply. Buyers are advised to conduct
                                    their own due diligence before assuming
                                    generic launch readiness.
                                  </span>
                                }
                                arrow
                              >
                                <span className="fs-14">{item.value}</span>
                              </Tooltip>
                            ) : (
                              item.value
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <h2 className="my-2  heading-bg-color text-white">
                  Supplier details
                </h2>
                <div
                  className="my-2 bx-shadow bg-white"
                  style={{ padding: "2rem" }}
                >
                  <div className="row py-2">
                    <div className="col-md-6 p-0">
                      <div className="p-3 mx-2">
                        {supplierData.map((service, index) => (
                          <div
                            key={index}
                            className={
                              service?.checked
                                ? "px-3 py-2 mx-2 my-4 ppil text-center align-items-center mb-3 dflex"
                                : "px-3 py-2 mx-2 my-4 opil text-center align-items-center mb-3 dflex"
                            }
                            style={{
                              justifyContent: "flex-start",
                              fontSize: "14px",
                            }}
                          >
                            <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                              {service?.img ? (
                                <>{service?.img}</>
                              ) : (
                                <>
                                  {service.checked ? (
                                    <CheckBoxIcon
                                      style={{
                                        color: "#6a1ca5",
                                        fontSize: "28px",
                                      }}
                                    />
                                  ) : (
                                    <DisabledByDefaultIcon
                                      style={{
                                        color: "#7B7B7B ",
                                        fontSize: "28px",
                                      }}
                                    />
                                  )}
                                </>
                              )}
                            </div>
                            <span className="  ms-4 fs-14 mb-0 fw-600 text-center ">
                              {service.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-md-6 p-0">
                      <div className="p-3 mx-2">
                        {supportServices.map((service, index) => (
                          <div
                            key={index}
                            className={
                              service?.checked
                                ? "px-3 py-2 mx-2 my-4  ppil text-center align-items-center mb-3 dflex"
                                : "px-3 py-2 mx-2 my-4  opil text-center align-items-center mb-3 dflex"
                            }
                            style={{
                              justifyContent: "flex-start",
                              fontSize: "14px",
                            }}
                          >
                            <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center">
                              {service?.img ? (
                                <>{service?.img}</>
                              ) : (
                                <>
                                  {service.checked ? (
                                    <CheckBoxIcon
                                      style={{
                                        color: "#6a1ca5",
                                        fontSize: "28px",
                                      }}
                                    />
                                  ) : (
                                    <DisabledByDefaultIcon
                                      style={{
                                        color: "#7B7B7B ",
                                        fontSize: "28px",
                                      }}
                                    />
                                  )}
                                </>
                              )}
                            </div>
                            <span className="  ms-4 fs-14 mb-0 fw-600 text-center ">
                              {service.name}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex1">
                <h2 className="my-2  heading-bg-color text-white">
                  Deal Contours
                </h2>
                {/* <table class="table bx-shadow">
                  <tbody>
                    {dealCounter &&
                      dealCounter.map((item, index) => (
                        <tr key={index}>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14 fw-600"
                                : "p-3 fs-14 fw-600"
                            }
                            style={{ width: "45%" }}
                          >
                            <span
                              className="me-4"
                              style={{ color: "#a947d3", fontSize: "24px" }}
                            >
                              <img
                                src={item?.image}
                                style={{ width: "28px" }}
                                alt="icon"
                              />
                            </span>

                            {item.label}
                          </td>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14"
                                : "p-3 fs-14"
                            }
                            style={{ width: "65%" }}
                          >
                            {item.value}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table> */}
                <table className="table bx-shadow">
                  <tbody>
                    {dealCounter
                      ?.filter((item) => {
                        const value = item?.value;

                        // hide row if value is empty
                        if (value === null || value === undefined) return false;
                        if (Array.isArray(value) && value.length === 0)
                          return false;
                        if (typeof value === "string" && value.trim() === "")
                          return false;

                        return true;
                      })
                      .map((item, index) => (
                        <tr key={index}>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14 fw-600"
                                : "p-3 fs-14 fw-600"
                            }
                            style={{ width: "45%" }}
                          >
                            <span
                              className="me-4"
                              style={{ color: "#a947d3", fontSize: "24px" }}
                            >
                              <img
                                src={item?.image}
                                style={{ width: "28px" }}
                                alt="icon"
                              />
                            </span>
                            {item.label}
                          </td>

                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14"
                                : "p-3 fs-14"
                            }
                            style={{ width: "65%" }}
                          >
                            {item.value}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <h2 className="my-2  heading-bg-color text-white">
                  Manufacturing Details
                </h2>
                {/* <table class="table  bx-shadow">
                  <tbody>
                    {manufDetails &&
                      manufDetails.map((item, index) => (
                        <tr key={index}>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14 fw-600"
                                : "p-3 fs-14 fw-600"
                            }
                            style={{ width: "45%" }}
                          >
                            <span
                              className="me-4"
                              style={{ color: "#a947d3", fontSize: "24px" }}
                            >
                              <img
                                src={item?.image}
                                style={{ width: "28px" }}
                                alt="icon"
                              />
                            </span>

                            {item.label}
                          </td>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14"
                                : "p-3 fs-14 "
                            }
                            style={{ width: "65%" }}
                          >
                            {item.value}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table> */}
                <table className="table bx-shadow">
                  <tbody>
                    {manufDetails
                      ?.filter((item) => {
                        const value = item?.value;

                        // hide row if value is empty
                        if (value === null || value === undefined) return false;
                        if (Array.isArray(value) && value.length === 0)
                          return false;
                        if (typeof value === "string" && value.trim() === "")
                          return false;

                        return true;
                      })
                      .map((item, index) => (
                        <tr key={index}>
                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14 fw-600"
                                : "p-3 fs-14 fw-600"
                            }
                            style={{ width: "45%" }}
                          >
                            <span
                              className="me-4"
                              style={{ color: "#a947d3", fontSize: "24px" }}
                            >
                              <img
                                src={item?.image}
                                style={{ width: "28px" }}
                                alt="icon"
                              />
                            </span>
                            {item.label}
                          </td>

                          <td
                            className={
                              grayTableRowPredicate(item.value)
                                ? "table-gray p-3 fs-14"
                                : "p-3 fs-14"
                            }
                            style={{ width: "65%" }}
                          >
                            {item.value}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <FirstButton
                  className="btn my-2"
                  buttonText="Request Term Sheet"
                  width="100%"
                  onClick={() => navigate(`/product-term-sheet/${id}`)}
                />
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <Card className="px-2 w100">
            <div className="d-flex flex-column align-items-center p-3">
              <img src={noData} style={{ width: "25%", height: "auto" }} />
              <h4 className="text-center light-text-color">
                Searched Dossier does not exist...
              </h4>

              <FirstButton
                className="borderbtn"
                buttonText="Back to Search Results"
                onClick={() => navigate("/dossier-search")}
              />
            </div>
          </Card>
        </>
      )}
    </div>
  );
};

export default ProductDetails;
